// extracted by mini-css-extract-plugin
module.exports = {"base":"organism2-m__base__2Hnim","en-base":"organism2-m__en-base__1MuN_","bn-base":"organism2-m__bn-base__1AvCU"};